// One list, read by the create select, the create action's schema and the Spec
// Review checklist. The column stays varchar, so a fifth value is data.
export const ANALYSIS_JOB_TYPES = [
  'resurfacing',
  'widening',
  'bridge',
  'other',
] as const;

export type AnalysisJobType = (typeof ANALYSIS_JOB_TYPES)[number];

export const ANALYSIS_JOB_TYPE_LABELS: Record<AnalysisJobType, string> = {
  resurfacing: 'Resurfacing',
  widening: 'Widening',
  bridge: 'Bridge',
  other: 'Other',
};
